import React from 'react';
import './home.scss';

export default function Home() {
  return (
    <React.Fragment>
      {/* <h2 className={'content-block'}>Agenti Xerjoff</h2> */}
      <img className={'xerjoff-logo'} src="/logoXerjoff.jpg" alt="Xerjoff logo" />
      <div className={'content-block'}>
        <div className={'dx-card responsive-paddings'}>
          <div className={'logos-container'}>             
            <a href="https://www.xerjoff.com/" target="_blank">
              <img className={'xerjoff-imghome'} src="/sfondo_home.jpg" alt="" />
            </a>
          </div>
        </div>
      </div>
    </React.Fragment>
)}
